import OGuideSwitch from './o-guide-switch.vue';

export default OGuideSwitch;